module.exports = __webpack_public_path__ + "static/media/renew.49dd9c38.svg";